import React from 'react';

import { Container, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import styled from '../../styled';
import { colorsPalette, MIDDLE_MARGIN_PX, SMALL_MARGIN_PX } from '../../theme';

const Maintenance = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Img
        height="70px"
        src="https://img-cdn.financeunlocked.com/logos/all-logos2.png?updatedAt=1635731447225"
        alt="logo"
      />
      <Title>{t('page.maintenance.wellBeBackSoon')}</Title>
      <Text>
        <Trans i18nKey="page.maintenance.sorryForTheInconvenience">
          Sorry for the inconvenience but we’re performing some maintenance at the moment. If you
          need to you can always
          <Link href="mailto:support@financeunlocked.com">contact us by email</Link>, otherwise
          we’ll be back online shortly!
        </Trans>
      </Text>
      <Text>— {t('page.maintenance.theUnlockedTeam')}</Text>
    </Wrapper>
  );
};

export default Maintenance;

const Wrapper = styled(Container)`
  && {
    max-width: 700px;
  }
  height: 100vh;
  width: 100%;
  padding-top: 100px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding-top: 150px;
  }
`;
const Img = styled('img')`
  width: 100%;
  object-fit: contain;
`;
const Title = styled(Typography)`
  margin: ${MIDDLE_MARGIN_PX} 0;
  font-size: 36px;
  font-weight: 700;
  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 50px;
  }
`;
const Text = styled(Typography)`
  font-size: 16px;
  color: ${colorsPalette.gray};
  &:not(:last-child) {
    margin-bottom: ${SMALL_MARGIN_PX};
  }
`;
const Link = styled('a')`
  color: ${colorsPalette.primary};
`;
